<template>
	<el-form-item label="是否为范围选择">
		<el-switch v-model="data.options.isRange" />
	</el-form-item>

	<template v-if="data.options.isRange">
		<el-form-item label="开始时间占位内容">
			<el-input v-model="data.options.startPlaceholder" />
		</el-form-item>
		<el-form-item label="结束时间占位内容">
			<el-input v-model="data.options.endPlaceholder" />
		</el-form-item>
	</template>
	<template v-else>
		<el-form-item label="占位内容">
			<el-input v-model="data.options.placeholder" />
		</el-form-item>
	</template>

	<el-form-item label="格式">
		<el-input v-model="data.options.format" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-time-picker
			v-if="data.options.isRange"
			v-model="data.options.defaultValue"
			style="width: 100%"
			:format="data.options.format"
			is-range
			:start-placeholder="data.options.startPlaceholder"
			:end-placeholder="data.options.endPlaceholder"
			clearable
		/>
		<el-time-picker
			v-else
			v-model="data.options.defaultValue"
			style="width: 100%"
			:format="data.options.format"
			:placeholder="data.options.placeholder"
			clearable
		/>
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemTime',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
